
export default {
    rfc({ value }) {
        const regex = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
        return value.match(regex);
    },

    curp({ value }) {
        const regex = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
        return value.match(regex);
    },

    coordinates: ({ value }) => {
        if (!value) return true

        const match = String(value).trim().match(
        /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/
        )

        if (!match) return false

        const lat = Number(match[1])
        const lng = Number(match[2])

        return lat >= -90 && lat <= 90 &&
            lng >= -180 && lng <= 180
    }
}
